import { List, Datagrid, TextField, NumberField, DateField, TextInput } from 'react-admin';
import { NUMBER_FORMATS, DATETIME_FORMAT } from '../../utils';
import { TagRemainingField, TagUsagePercentageField } from './TagUsageFields';
import { ListActions } from '../common';

const tagFilters = [
  <TextInput key="q" source="q" label="Search" alwaysOn />,
  <TextInput key="tag" source="tag" label="Tag" />,
];

export const TagList = () => {
  return (
    <List
      filters={tagFilters}
      sort={{ field: 'createdAt', order: 'DESC' }}
      actions={<ListActions />}
    >
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="id" label="ID" />
        <TextField source="tag" label="Tag" />
        <TextField source="material" label="Material" />
        <TextField source="color" label="Color" />
        <TextField source="profileVersion" label="Profile" defaultValue="" />
        <NumberField
          source="weight"
          label="Weight (g)"
          options={NUMBER_FORMATS.weight}
          textAlign="left"
        />
        <TagRemainingField label="Remaining (g)" />
        <TagUsagePercentageField label="Usage %" />
        <DateField source="createdAt" label="Created At" showTime options={DATETIME_FORMAT} />
      </Datagrid>
    </List>
  );
};
